import { render, staticRenderFns } from "./TaskRecord.vue?vue&type=template&id=1b1806c4&scoped=true"
import script from "./TaskRecord.vue?vue&type=script&lang=js"
export * from "./TaskRecord.vue?vue&type=script&lang=js"
import style0 from "./TaskRecord.vue?vue&type=style&index=0&id=1b1806c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1806c4",
  null
  
)

export default component.exports